import React from "react";

import s from "./Description.module.scss";

const DescriptionSprint = () => {
  return (
    <div className={s.description}>
      <h2>Спринт</h2>
      <p>
        Изучать английский язык это весело! Проверьте свои знания, а также
        закрепите успехи в игре Спринт. Вам будет показано на экране английское
        слово и его русский перевод, если перевод верный, нажимайте кнопку
        "Верно", если перевод не верный, кнопку "Неверно". За правильные ответы
        вам будут начисляться баллы. За несколько угаданных слов подряд будут начисляться дополнительные баллы.
      </p>
    </div>
  );
};

export default DescriptionSprint;
